import React from "react";

function EyeButtonIcon() {
  return (
    <svg
      width="22"
      height="20"
      viewBox="0 0 22 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width="20.7692" height="20" rx="6" fill="white" />
      <circle
        cx="10.7693"
        cy="10.0005"
        r="1.40128"
        stroke="#595959"
        stroke-width="1.3"
      />
      <path
        d="M14.8345 9.29322C15.0969 9.59906 15.2281 9.75198 15.2281 9.9988C15.2281 10.2456 15.0969 10.3985 14.8345 10.7044C14.055 11.6128 12.5268 13.0757 10.7692 13.0757C9.01156 13.0757 7.4834 11.6128 6.70393 10.7044C6.4415 10.3985 6.31029 10.2456 6.31029 9.9988C6.31029 9.75198 6.4415 9.59906 6.70394 9.29322C7.4834 8.38483 9.01156 6.92188 10.7692 6.92188C12.5268 6.92188 14.055 8.38483 14.8345 9.29322Z"
        stroke="#595959"
        stroke-width="1.3"
      />
    </svg>
  );
}

export default EyeButtonIcon;
